<!-- Prima questo dialog era un <div> centrato con un <h5> al posto del titolo:
     restava fuori dalla grammatica degli altri, e soprattutto titolo,
     contenuto e azioni non erano figli DIRETTI della superficie, quindi la
     fascia panna non poteva stare a filo del bordo inferiore. -->
<h2 mat-dialog-title>Condividi link di invito</h2>

<mat-dialog-content>
  <p class="izy-invite-message">
    Chi apre questo link potrà unirsi alla tua organizzazione:
  </p>

  <mat-form-field appearance="outline" class="izy-invite-field">
    <mat-label>Link di invito</mat-label>
    <input matInput [value]="data.invitationLink" readonly #linkInput />
    <!-- La copia e' a portata di mano anche da qui, oltre che dal pulsante
         della fascia: e' il gesto per cui il dialog si apre. -->
    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="copyToClipboard()"
      aria-label="Copia link">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <!-- Chiude solo via onCancel(), che restituisce `false`: prima c'era anche
       mat-dialog-close, che chiude con `undefined`, e a seconda di quale dei
       due arrivava prima il chiamante riceveva un risultato diverso. -->
  <button
    mat-stroked-button
    type="button"
    (click)="onCancel()"
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Annulla
  </button>

  <!-- L'azione della schermata: petrol pieno bordato nero. -->
  <button
    matButton="filled"
    type="button"
    (click)="copyToClipboard()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>content_copy</mat-icon>
    Copia link
  </button>
</mat-dialog-actions>
